import { lazy, Suspense, useEffect, useRef } from "react";
import {
	Route,
	BrowserRouter as Router,
	Routes,
	useLocation,
	useNavigationType,
} from "react-router-dom";
import Home from "./Home";

const PrivacyPolicy = lazy(() => import("./PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./TermsOfUse"));

// Store scroll position per pathname across the session
const scrollPositions = {};

function ScrollToTop() {
	const { pathname } = useLocation();
	const navigationType = useNavigationType();
	const prevPathname = useRef(pathname);

	// Save scroll position of the page we're LEAVING
	useEffect(() => {
		return () => {
			scrollPositions[prevPathname.current] = window.scrollY;
		};
	}, [pathname]);

	useEffect(() => {
		prevPathname.current = pathname;

		if (navigationType === "POP" && scrollPositions[pathname] !== undefined) {
			requestAnimationFrame(() => {
				window.scrollTo(0, scrollPositions[pathname]);
			});
		} else if (navigationType !== "POP") {
			window.scrollTo(0, 0);
		}
	}, [pathname, navigationType]);

	return null;
}

function App() {
	useEffect(() => {
		if ("scrollRestoration" in window.history) {
			window.history.scrollRestoration = "manual";
		}
	}, []);

	return (
		<Router>
			<ScrollToTop />
			<Suspense fallback={null}>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/privacypolicy" element={<PrivacyPolicy />} />
					<Route path="/terms-of-use" element={<TermsOfUse />} />
				</Routes>
			</Suspense>
		</Router>
	);
}

export default App;
